import { getNoBidClientStyle } from 'utils/helpers'

export const fromContacts = contacts =>
  contacts.map(contact => ({
    label: contact.firstName + ' ' + contact.lastName,
    value: contact.id,
    phone: contact.phone,
    email: contact.email
  }))

export const fromCompany = company => ({
  value: company.id,
  label: company.name,
  color: getNoBidClientStyle(company.noBid).color
})
